/**
 * ISO-3166 country code
 * https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
 */
export const COUNTRY_CODE = {
    KZ: 'KZ',
    UZ: 'UZ',
    UA: 'UA',
    RO: 'RO',
    PT: 'PT',
    BG: 'BG',
    PL: 'PL'
} as const;
